class XMPPResource {
    constructor(config, whereIsUser) {
        if (config.user !== undefined) {
            this.username = config.user.u;
            this.userid = config.user.id;
        } else {
            this.username = null;
            this.userid = null;
        }
        this.domain = config.domain;

        this.whereIsUser = whereIsUser;
    }

    bareJID() {
        return this.username + '@' + this.domain;
    }

    fullJID() {
        return this.bareJID() + '/' + this.resource();
    }

    resource() {
        return this.domain + '::' + this.userid + ':' + this.whereIsUser + ':' + this.getGUID() + ':';
    }

    getGUID() {
        let str = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
        str = str.replace(/[xy]/g, function (c) {
            let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
        return str;
    }
}
